<template>
    <div>
        <h1>Locker Modules</h1>
        
        <!-- Modules Overview -->
        <div  v-if="!$route.params.id">
            <button @click="showCreate = !showCreate">{{showCreate ?'Hide':'Show'}} Create</button>
            <ModuleCreate v-if="showCreate"></ModuleCreate>
            <hr>
            <ModuleList></ModuleList>
        </div>
        <ModuleDetail v-if="$route.params.id"></ModuleDetail>
    </div>
</template>

<script>
    // Import Helpers
    import {EnsureUserLoggedin} from '../Utilities.js'
    import ModuleCreate from '../components/ModuleCreate'
    import ModuleList from '../components/ModuleList'
    import ModuleDetail from '../components/ModuleDetail'

    // Module Code
    export default {
        beforeRouteEnter: EnsureUserLoggedin,
        components: {ModuleCreate, ModuleList, ModuleDetail},
        props: ['id'],
        data: function() {
            return {
                showCreate: false
            }
        }
    }
</script>